function createCustomEvent(eventName: string, obj: any) {
	const event = new CustomEvent(eventName, { detail: obj })
	document.dispatchEvent(event)
}

function createGAEvent(eventNameGA: string, objOther = {}) {
	const params = { name: eventNameGA }
	createCustomEvent('event_tracking', {
		...params,
		...objOther,
	})
}

enum GaGeneralEvent {
	PageLoad = 'page_load',
	ButtonClick = 'button_click',
	ButtonImpression = 'button_impression',
	LoginSignupStart = 'login_sign_up_start',
}

enum GaGeneralPageName {
	HomePage = 'Homepage',
	UserPreferencePage = 'User Preference Page',
	InvitePage = 'Referral Invite Page',
	CommunityPostListingPage = 'Community Post Listing Page',
	CommunityPostDetailPage = 'Community Post Detail Page',
	ShippingB2B = 'B2B Homepage',
	ShippingB2BNext = 'B2B Next Homepage',
	// Should update after document updated
	MercariBrand = 'Brand Page',
	MercariIndex = 'Product Listing Page',
	MercariDetail = 'Product Detail Page',
	MercariCampaign = 'Campaign Page',
	ShippingProtection = 'Shipment Protection Page',
	ShoppingProtection = 'Shopping Protection Page',
	Shipping = 'Shipping Page',
	ProxyShopping = 'Proxy Shopping Page',
	YahooLanding = 'Yahoo Landing Page',
}

export { createCustomEvent, createGAEvent, GaGeneralEvent, GaGeneralPageName }
